import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { fetchUserDetailsByMobileData } from "../../../redux/reducers/apiSlice";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import SelectDropdown from "../../components-react/SelectDropdown";
import { userHandoverTrainer } from "../../../redux/reducers/postApiSlice";
import {
  fetchInHouseUsersData,
  fetchTrainerBySlotData,
} from "../../../redux/reducers/dropdownApiSlice";
import { updateUserHandoverTrainer } from "../../../redux/reducers/putApiSlice";
import { timeSlots } from "../../common-data/DropdowData";
import { getCurrentDate } from "../../common-data/Converts";
// import { convertTo24HourFormat } from "../../common-data/Converts";

const ReceptionistForm = ({
  receptionistInfo,
  closeModal,
  decryptedText,
  callFunction,
  name,
  rowData,
  isShowBackBtn,
}) => {
  const dispatch = useDispatch();
  const {
    // allTrainerByExpLvlData,
    userDetailsByMobile,
  } = useSelector((state) => state.api);
  // const trainersData = useSelector(selectTrainersData);
  const { inhouseUsers, trainersDataBySlot } = useSelector(
    (state) => state.dropdown
  );

  // const [allTrainers, setAllTrainers] = useState([]);
  const isFitnessManager = decryptedText?.account_type === "fitness_manager";

  const iniUserInfo = {
    mobile:
      (name === "edit" || name === "initiate-handover") && rowData?.user_mobile
        ? rowData.user_mobile
        : "",
    email:
      (name === "edit" || name === "initiate-handover") && rowData?.user_email
        ? rowData.user_email
        : "",
    name:
      (name === "edit" || name === "initiate-handover") && rowData?.user_name
        ? rowData.user_name
        : "",
    gender:
      (name === "edit" || name === "initiate-handover") && rowData?.gender
        ? { label: rowData.gender, value: rowData.gender }
        : "",
    user_id:
      (name === "edit" || name === "initiate-handover") && rowData?.user_id
        ? rowData.user_id
        : "",
    gym_id:
      (name === "edit" || name === "initiate-handover") && rowData?.gym_id
        ? rowData.gym_id
        : "",
    is_biomax_registered:
      (name === "edit" || name === "initiate-handover") &&
      rowData?.is_biomax_registered === "true"
        ? true
        : false,
  };
  const [userInfo, setUserInfo] = useState(iniUserInfo);
  const [isFetchUser, setIsFetchUser] = useState(false);
  const [whoIsUser, setWHoIsUser] = useState("");

  const iniFormValues = {
    receptionistName: receptionistInfo?.name || "",
    receptionistMobile: receptionistInfo?.mobile || "",
    receptionistEmail: receptionistInfo?.email || "",
    receptionistId: receptionistInfo?.user_id || "",
    gymId: receptionistInfo?.gym_id || "",
    gymName: receptionistInfo?.gym_name || "",

    userName: userInfo.name,
    userId: userInfo.user_id,
    userMobile: userInfo.mobile,

    selectedTrainer:
      name === "edit" && rowData?.trainer_id
        ? { label: rowData?.trainer_name, value: rowData?.trainer_id }
        : "",

    selectedHandoverFrom: "",
    trialDate:
      name === "edit" && rowData?.pt_schedule_date
        ? rowData.pt_schedule_date
        : "",
    selectedSlot: "",
    clickedTrainerId: "",
    isAssignToSelf: false,
    isTrainerIntro:
      name === "edit" && rowData?.trnr_intro_status === "completed"
        ? true
        : name === "edit" && rowData?.trnr_intro_status === "pending"
        ? false
        : false,
  };
  const [formValues, setFormValues] = useState(iniFormValues);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const onClickFetchUserDetails = (name) => {
    setWHoIsUser(name);

    const handleConfirm = () => {
      if (
        name === "user-info"
          ? userInfo.mobile && userInfo.mobile?.length === 10
          : formValues.receptionistMobile &&
            formValues.receptionistMobile?.length === 10
      ) {
        dispatch(
          fetchUserDetailsByMobileData({
            userMobile: userInfo.mobile,
            token: decryptedText?.token,
          })
        );
        setIsFetchUser(true);
      } else {
        toast.error("Please Enter Mobile Number! (Number Must Be 10 Digit)");
      }
    };

    showConfirmAlert(
      handleConfirm,
      `Is the entered ${
        name === "user-info" ? userInfo.mobile : formValues.receptionistMobile
      } number correct?`
    );
  };

  const onChangeInput = (e) => {
    e.preventDefault();

    const { name, value, type, checked, files } = e.target;
    const file = type === "file" ? files[0] : null;

    setFormValues((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : type === "file" ? file : value,
    }));
    setIsSubmit(false);
  };

  const onChangeInputCheckbox = (e) => {
    const { name, checked } = e.target;

    setFormValues((prev) => ({
      ...prev,
      [name]: checked,
    }));
    setIsSubmit(false);
  };

  const onChangeDropdown = (name, value) => {
    setFormValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleBack = () => {
    setFormValues(iniFormValues);
    setFormErrors({});
    setUserInfo(iniUserInfo);
    setIsFetchUser(false);
  };

  const validateForm = (formValues) => {
    let errors = {};

    if (!formValues.trialDate) {
      errors.trialDate = "Required!";
    }

    if (name !== "edit" && !formValues.selectedSlot) {
      errors.selectedSlot = "Required!";
    }

    if (!formValues.selectedTrainer) {
      errors.selectedTrainer = "Trainer Is Required!";
    }

    if (isFitnessManager) {
      if (!formValues.selectedTrainer && !formValues.isAssignToSelf) {
        errors.selectedTrainer = "Trainer Is Required!";
        errors.isAssignToSelf = "Trainer Is Required!";
      } else if (formValues.selectedTrainer && formValues.isAssignToSelf) {
        errors.selectedTrainer = "Both Cann't Be True!";
        errors.isAssignToSelf = "Trainer Is Required!";
      }
    } else {
      if (!formValues.selectedTrainer) {
        errors.selectedTrainer = "Trainer Is Required!";
      }
    }

    if (!formValues.isTrainerIntro) {
      errors.isTrainerIntro = "required!";
    }

    return errors;
  };

  const handleAdd = async (requestBody, TOKEN) => {
    setIsSubmit(false);

    try {
      const actionResult =
        name === "edit"
          ? dispatch(updateUserHandoverTrainer({ requestBody, TOKEN }))
          : dispatch(userHandoverTrainer({ requestBody, TOKEN }));
      const result = await actionResult;

      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Success!");
        setFormValues(iniFormValues);
        setFormErrors({});
        closeModal();
        callFunction();
      } else {
        const errorMessage = result?.error?.message || result?.payload?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.log("handleAdd ERROR => ", error);
    }
  };

  const onSubmit = () => {
    setFormErrors(validateForm(formValues));
    setIsSubmit(true);
  };

  function getTrainersBySlot(filter) {
    dispatch(
      fetchTrainerBySlotData({
        filters: filter,
        token: decryptedText?.token,
      })
    );
  }

  useEffect(() => {
    if (
      isFetchUser &&
      userDetailsByMobile?.status &&
      userDetailsByMobile?.data?.length > 0
    ) {
      setIsFetchUser(false);

      const { uid, name, email, gym_id, account_type, is_biomax_registered } =
        userDetailsByMobile?.data?.[0];

      if (whoIsUser === "user-info") {
        if (receptionistInfo?.gym_id === gym_id && account_type === "member") {
          setUserInfo((prevs) => ({
            ...prevs,
            email: email,
            name: name,
            user_id: uid,
            is_biomax_registered: is_biomax_registered,
          }));
        } else if (account_type !== "member") {
          toast.error(
            "Oops🙊! Entered Mobile Number Doesn't Belong To A Member!"
          );
        } else if (receptionistInfo?.gym_id !== gym_id) {
          toast.error("Oops🙊! User Is Belong To Different Gym!");
        } else {
          toast.error("Oops🙊! Something Wrong!");
        }
      } else if (whoIsUser === "receptionist-info") {
        if (account_type === "receptionist") {
          setFormValues((prevs) => ({
            ...prevs,
            receptionistEmail: email,
            receptionistName: name,
            receptionistId: uid,
          }));
        } else if (account_type !== "receptionist") {
          toast.error(
            "Oops🙊! Entered Mobile Number Doesn't Belong To A  Sales Executive/Front-desk!"
          );
        }
      }
    } else if (isFetchUser && userDetailsByMobile?.status === false) {
      toast.error(userDetailsByMobile?.message);
      return;
    }
  }, [userDetailsByMobile]);

  useEffect(() => {
    if (Object.keys(userInfo)?.length > 0) {
      setFormValues((prevs) => ({
        ...prevs,
        receptionistId: receptionistInfo?.user_id,
        gymId: receptionistInfo?.gym_id,
        userName: userInfo.name,
        userId: userInfo.user_id,
        userMobile: userInfo.mobile,
      }));
    }
  }, [userInfo]);

  useEffect(() => {
    if (isFitnessManager) {
      dispatch(
        fetchInHouseUsersData({
          token: decryptedText?.token,
          qps:
            userInfo?.gym_id || formValues.gymId || decryptedText?.gym_id
              ? `gym_id=${
                  userInfo?.gym_id || formValues.gymId || decryptedText?.gym_id
                }`
              : isFitnessManager
              ? `account_type=receptionist`
              : "",
          pageNo: 1,
          limit: 100,
        })
      );
    }
  }, [formValues.gymId]);

  useEffect(() => {
    if (formValues.selectedSlot) {
      const [start, end] = formValues.selectedSlot.value.split("-");

      const filters = {
        gym_id:
          userInfo?.gym_id || formValues.gymId || decryptedText?.gym_id
            ? userInfo?.gym_id || formValues.gymId || decryptedText?.gym_id
            : rowData?.gym_id
            ? rowData.gym_id
            : "",
        slot_start_time: start,
        slot_end_time: end,
      };
      getTrainersBySlot(filters);
    }
  }, [formValues.selectedSlot]);

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const userData = {
        user_id: formValues.userId,
        assigned_by:
          isFitnessManager && formValues.selectedHandoverFrom?.value
            ? formValues.selectedHandoverFrom?.value
            : formValues.receptionistId
            ? formValues.receptionistId
            : decryptedText?.uid || decryptedText?.user_id || "",
        assigned_to:
          isFitnessManager && formValues.isAssignToSelf
            ? decryptedText?.user_id
            : formValues.selectedTrainer?.value,
        pt_schedule_date: formValues.trialDate,
        trnr_intro: formValues.isTrainerIntro ? "completed" : "pending",
      };

      const formData = new FormData();

      for (const key in userData) {
        if (userData.hasOwnProperty(key)) {
          formData.append(key, userData[key]);
        }
      }

      if (name === "edit") {
        formData.append("uid", rowData.uid);
        formData.append("is_updateHandoverData", true);
        formData.append("gym_id", rowData.gym_id);
      }

      handleAdd(formData, decryptedText?.token);
    }
  }, [isSubmit, formErrors]);

  console.log("receptionistInfo=> ", receptionistInfo);

  return (
    <div className="form-container">
      <form className="formContainer">
        {/* RECEPTIONIST INFO */}
        {receptionistInfo ? (
          <div className="formInputsGrid fourGridSystem">
            <div className="formInputBox">
              <label htmlFor="name" className="formInputLabel">
                Name (Handover From)
              </label>

              <input
                type="text"
                className="formInput"
                name="name"
                placeholder={`🚫 ${receptionistInfo?.name || "NA"}`}
                disabled
              />
            </div>
            <div className="formInputBox">
              <label htmlFor="mobile" className="formInputLabel">
                Mobile Number (Handover From)
              </label>

              <input
                type="number"
                className="formInput"
                name="mobile"
                placeholder={`🚫 ${receptionistInfo?.mobile || "NA"}`}
                disabled
              />
            </div>
            <div className="formInputBox">
              <label htmlFor="email" className="formInputLabel">
                Email (Handover From)
              </label>

              <input
                type="email"
                className="formInput"
                style={{
                  textTransform: "lowercase",
                }}
                name="email"
                placeholder={`🚫 ${
                  receptionistInfo?.email?.toLowerCase() || "NA"
                }`}
                disabled
              />
            </div>
            <div className="formInputBox">
              <label htmlFor="gym_name" className="formInputLabel">
                Gym Name (Handover From)
              </label>

              <input
                type="text"
                className="formInput"
                name="gym_name"
                placeholder={`🚫 ${receptionistInfo?.gym_name || "NA"}`}
                disabled
              />
            </div>
            <div className="formInputBox">
              <label htmlFor="account_type" className="formInputLabel">
                Account Type (Handover From)
              </label>

              <input
                type="text"
                className="formInput"
                name="account_type"
                placeholder={`🚫 ${
                  receptionistInfo?.account_type === "receptionist"
                    ? "Sales Executive"
                    : receptionistInfo?.account_type?.replace(/_/g, " ") || "NA"
                }`}
                disabled
              />
            </div>
          </div>
        ) : (
          <div className="formInputsGrid userDetails">
            {!formValues.receptionistId ? (
              <div className="formInputBox withButton">
                <label htmlFor="receptionistMobile" className="formInputLabel">
                  Sales Executive/Front-desk Mobile{" "}
                  <span className="required">*</span>
                </label>

                <div
                  className={`commonInputWrapper twoInput ${
                    formValues.receptionistId ? "long" : "short"
                  }`}
                >
                  <input
                    type="number"
                    className="formInput"
                    name="receptionistMobile"
                    placeholder="Enter Mobile Number"
                    value={formValues.receptionistMobile}
                    onChange={onChangeInput}
                  />
                  {!formValues.receptionistId && (
                    <button
                      type="button"
                      className="searchBtn"
                      onClick={() =>
                        onClickFetchUserDetails("receptionist-info")
                      }
                    >
                      Fetch User Details
                    </button>
                  )}
                </div>
              </div>
            ) : (
              <>
                <div className="formInputBox">
                  <label
                    htmlFor="receptionistMobile"
                    className="formInputLabel"
                  >
                    Sales Executive/Front-desk Mobile
                  </label>

                  <input
                    type="number"
                    className="formInput"
                    name="receptionistMobile"
                    placeholder={`🚫 ${formValues.receptionistMobile || "NA"}`}
                    disabled
                  />
                </div>
                <div className="formInputBox">
                  <label htmlFor="receptionistName" className="formInputLabel">
                    Sales Executive/Front-desk Name
                  </label>

                  <input
                    type="text"
                    className="formInput"
                    name="receptionistName"
                    placeholder={`🚫 ${formValues.receptionistName || "NA"}`}
                    disabled
                  />
                </div>
                <div className="formInputBox">
                  <label htmlFor="receptionistEmail" className="formInputLabel">
                    Sales Executive/Front-desk Email
                  </label>

                  <input
                    type="email"
                    className="formInput"
                    name="receptionistEmail"
                    placeholder={`🚫 ${
                      formValues.receptionistEmail?.toLowerCase() || "NA"
                    }`}
                    disabled
                  />
                </div>
                <div className="formInputBox">
                  <label htmlFor="gymName" className="formInputLabel">
                    Gym Name
                  </label>

                  <input
                    type="email"
                    className="formInput"
                    name="gymName"
                    placeholder={`🚫 ${
                      formValues.gymName?.toLowerCase() || "NA"
                    }`}
                    disabled
                  />
                </div>
              </>
            )}
          </div>
        )}
        {/* ------------ RECEPTIONIST INFO ------------ */}

        <div className="grayLine"></div>

        <div className="formInputsGrid userDetails fourGridSystem">
          {name !== "edit" && !userInfo.user_id && (
            <div className="formInputBox withButton">
              <label htmlFor="mobile" className="formInputLabel">
                Member Number <span className="required">*</span>
              </label>

              <div
                className={`commonInputWrapper twoInput ${
                  userInfo.user_id ? "long" : "short"
                }`}
              >
                <input
                  type="number"
                  className="formInput"
                  name="mobile"
                  placeholder="Enter User Number"
                  value={userInfo.mobile}
                  onChange={(e) =>
                    setUserInfo((prevs) => ({
                      ...prevs,
                      mobile: e.target.value,
                    }))
                  }
                />
                {!userInfo.user_id && (
                  <button
                    type="button"
                    className="searchBtn"
                    onClick={() => onClickFetchUserDetails("user-info")}
                  >
                    Fetch User Details
                  </button>
                )}
              </div>
            </div>
          )}
          {userInfo.user_id && (
            <>
              <div className="formInputBox">
                <label htmlFor="mobile" className="formInputLabel">
                  Member Mobile
                </label>

                <input
                  type="number"
                  className="formInput"
                  name="mobile"
                  placeholder={`🚫 ${userInfo?.mobile || "NA"}`}
                  disabled
                />
              </div>
              <div className="formInputBox">
                <label htmlFor="name" className="formInputLabel">
                  Member Name
                </label>

                <input
                  type="text"
                  className="formInput"
                  name="name"
                  placeholder={`🚫 ${userInfo?.name || "NA"}`}
                  disabled
                />
              </div>
              <div className="formInputBox">
                <label htmlFor="email" className="formInputLabel">
                  Member Email
                </label>

                <input
                  type="email"
                  className="formInput"
                  name="email"
                  placeholder={`🚫 ${userInfo?.email?.toLowerCase() || "NA"}`}
                  disabled
                />
              </div>

              {isFitnessManager && (
                <div className="formInputBox">
                  <label
                    htmlFor="selectedHandoverFrom"
                    className="formInputLabel"
                  >
                    Change Handover From
                  </label>

                  <div
                    className={`commonWrapper ${
                      formErrors.selectedHandoverFrom && "formError"
                    }`}
                  >
                    <SelectDropdown
                      options={inhouseUsers?.filter(
                        (value) => !value?.label?.includes("(trainer)")
                      )}
                      selectedOption={formValues.selectedHandoverFrom}
                      setSelectedOption={(selectedValue) =>
                        onChangeDropdown("selectedHandoverFrom", selectedValue)
                      }
                      name=""
                    />
                  </div>
                </div>
              )}

              <div className="formInputBox">
                <label htmlFor="trialDate" className="formInputLabel">
                  Trial Date <span className="required">*</span>
                </label>

                <div className={`commonInputWrapper`} style={{ width: "100%" }}>
                  <input
                    type="date"
                    className={`formInput ${
                      formValues.trialDate ? "date-has-value" : ""
                    } ${formErrors.trialDate && "formError"}`}
                    name="trialDate"
                    placeholder="Enter User Number"
                    value={formValues.trialDate}
                    onChange={(e) =>
                      setFormValues((prevs) => ({
                        ...prevs,
                        trialDate: e.target.value,
                      }))
                    }
                    min={getCurrentDate()}
                  />
                </div>
              </div>

              {name === "edit" && rowData?.trainer_id && (
                <div className="formInputBox">
                  <label htmlFor="mobile" className="formInputLabel">
                    Current Assigned To
                  </label>

                  <input
                    type="number"
                    className="formInput"
                    name="mobile"
                    placeholder={`🚫 ${
                      formValues?.selectedTrainer?.label || "NA"
                    }`}
                    disabled
                  />
                </div>
              )}

              <div className="formInputBox">
                <label htmlFor="selectedSlot" className="formInputLabel">
                  Select Slot <span className="required">*</span>
                </label>

                <div
                  className={`commonWrapper ${
                    formErrors.selectedSlot && "formError"
                  }`}
                >
                  <SelectDropdown
                    options={timeSlots}
                    selectedOption={formValues.selectedSlot}
                    setSelectedOption={(selectedValue) =>
                      onChangeDropdown("selectedSlot", selectedValue)
                    }
                    name="Slot"
                  />
                </div>
              </div>

              {formValues.selectedSlot ? (
                <div className="formInputBox span4">
                  <label htmlFor="selectedTrainer" className="formInputLabel">
                    Trainer (Assign To) <span className="required">*</span>
                  </label>

                  {trainersDataBySlot?.length > 0 ? (
                    <div
                      className={`availble-trainer-slotwise ${
                        formErrors.selectedTrainer ? "formError" : ""
                      }`}
                    >
                      {trainersDataBySlot.map((item, index) => (
                        <div
                          className={`trainerbox ${
                            formValues.clickedTrainerId === item?.value
                              ? "active"
                              : ""
                          }`}
                          key={index}
                          onClick={() => {
                            setFormValues((prevs) => ({
                              ...prevs,
                              selectedTrainer: {
                                label: item?.info?.trainer_name || "NA",
                                value: item?.value || "",
                              },
                              clickedTrainerId:
                                prevs.clickedTrainerId === item?.value
                                  ? ""
                                  : item?.value,
                            }));
                          }}
                        >
                          <span className="name">
                            {item?.info?.trainer_name || "NA"}
                          </span>
                          <span className="shifts">{item?.label || "-"}</span>
                          <span className="value">
                            Ongoing PT: {item?.info?.total_active_pt || 0}
                          </span>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <span className="info">
                      No Trainer Availble On This Slot
                    </span>
                  )}

                  {trainersDataBySlot?.length > 0 &&
                  formErrors.selectedTrainer ? (
                    <span className="info-red">
                      Trainer Is Not Selected! (Click On The Trainer To Select
                      Trainer)
                    </span>
                  ) : null}
                </div>
              ) : null}
            </>
          )}
        </div>

        {userInfo.user_id && (
          <div className="formInputsGrid switchInputs">
            <div className="formInputBox formInputSwitchBox">
              <div className={`formInputBox span3 check-input-not-bar`}>
                <Form.Check
                  type="checkbox"
                  name="isTrainerIntro"
                  id="isTrainerIntro"
                  className={`no-border ${
                    formErrors?.isTrainerIntro ? "formError" : ""
                  } ${formValues.isTrainerIntro ? "active" : ""}`}
                  style={{
                    cursor: "pointer",
                  }}
                  label={`${
                    formValues.isTrainerIntro
                      ? "Trainer Introduction Done"
                      : "Is Trainer Introduction Done?"
                  }`}
                  checked={formValues.isTrainerIntro}
                  onChange={onChangeInputCheckbox}
                />
              </div>
            </div>
          </div>
        )}

        {isFitnessManager && (
          <div className="formInputsGrid switchInputs">
            <div className="formInputBox formInputSwitchBox">
              <div className={`commonWrapper commonSwitchWrapper`}>
                <Form.Check
                  type="switch"
                  name="isAssignToSelf"
                  className={`${formErrors?.isAssignToSelf ? "formError" : ""}`}
                  label={`${
                    formValues.isAssignToSelf
                      ? "Assigned To Self"
                      : "Assign To Self"
                  }`}
                  checked={formValues.isAssignToSelf}
                  value={formValues.isAssignToSelf}
                  onChange={onChangeInput}
                />
              </div>
            </div>
          </div>
        )}

        <div className="grayLine"></div>

        {userInfo.user_id && (
          <>
            <div className="formButtons" style={{ justifyContent: "flex-end" }}>
              {isShowBackBtn && (
                <Button
                  className="saveBtn"
                  variant="outline-danger"
                  onClick={handleBack}
                >
                  Back
                </Button>
              )}

              <Button className="saveBtn" variant="danger" onClick={onSubmit}>
                {name === "edit" ? "Update" : "Submit"}
              </Button>
            </div>
          </>
        )}
      </form>
    </div>
  );
};

export default ReceptionistForm;
